<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">نرم‌افزارهای مرتبط</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label fw-bold">نام نرم‌افزار</label>
          <input
              type="text"
              class="form-control"
              placeholder="نام نرم‌افزار را وارد کنید"
              v-model="newSoftware.name"
          />
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">نوع نرم‌افزار</label>
          <select class="form-select" v-model="newSoftware.type">
            <option value="" disabled>نوع نرم‌افزار را انتخاب کنید</option>
            <option :value="type" v-for="(type, index) in types" :key="index">
              {{ type }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addSoftware"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Softwares Table -->
      <GeneralTable
          :headers="['نام نرم‌افزار', 'نوع نرم‌افزار']"
          :fields="['name', 'type']"
          :items="jobQualification.related_softwares"
          :openEditModalMethod="openEditModal"
          @remove="removeSoftware"
      />

      <!-- Edit Software Modal -->
      <GeneralModal
          v-show="editedSoftware"
          title="ویرایش نرم‌افزار مرتبط"
          modal-id="softwareModalId"
          @save="updateSoftware"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">نام نرم‌افزار</label>
            <input
                type="text"
                class="form-control"
                placeholder="نام نرم‌افزار را وارد کنید"
                v-if="editedSoftware"
                v-model="editedSoftware.name"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">نوع نرم‌افزار</label>
            <select class="form-select" v-if="editedSoftware" v-model="editedSoftware.type">
              <option value="" disabled>نوع نرم‌افزار را انتخاب کنید</option>
              <option :value="type" v-for="(type, index) in types" :key="index">
                {{ type }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  name: "",
  type: ""
}
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  data() {
    return {
      newSoftware: structuredClone(baseStructure),
      types: ['عمومی', 'تخصصی'],
      editedSoftware: null,
      editIndex: null,
    };
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      }
    },
  },
  methods: {
    async addSoftware() {
      if (!this.newSoftware.name || !this.newSoftware.type) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newSoftware,
        endpoint: '/job-qualifications/store-related-software',
      })

      this.jobQualification.related_softwares = [...this.jobQualification.related_softwares, structuredClone(response.data)];
      this.newSoftware = structuredClone(baseStructure);
    },
    removeSoftware(index) {
      const relatedSoftware = this.jobQualification.related_softwares.find((_, i) => i === index);
      this.jobQualification.related_softwares = this.jobQualification.related_softwares.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: relatedSoftware.id,
        endpoint: '/job-qualifications/delete-related-software',
      })
    },
    openEditModal(software, index) {
      this.editedSoftware = structuredClone(software);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('softwareModalId'));
      modal.show();
    },
    updateSoftware() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedSoftware.name || !this.editedSoftware.type) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      this.jobQualification.related_softwares.splice(this.editIndex, 1, {...this.editedSoftware});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedSoftware,
        endpoint: '/job-qualifications/update-related-software',
      })

      this.editIndex = null;
      this.editedSoftware = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('softwareModalId'));
      modal.hide();
    }
  }
};
</script>
